import script from "./CollaborativeInspection.vue?vue&type=script&setup=true&lang=js"
export * from "./CollaborativeInspection.vue?vue&type=script&setup=true&lang=js"

import "./CollaborativeInspection.vue?vue&type=style&index=0&id=617f1d12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617f1d12"]])

export default __exports__